import React from 'react';
import styled from 'styled-components';
import Image from 'next/image';
import Search from '@/containers/ina/index/Search';

import { FontStyle } from '@/utils/StyleUtil';

const QNAExplain = () => {
    return (
        <HeaderExplainContainer>
            <Title>{`보험에 대해\n궁금한 것이 있다면\n검색해보세요`}</Title>
            <ImageWrapper>
                <Image
                    src={'/img/ina/qna_main_male@3x.gif'}
                    alt="qna_main"
                    width="132px"
                    height="153px"
                    priority={true}
                />
            </ImageWrapper>
            <Search />
        </HeaderExplainContainer>
    );
};

// react multi carolsule compatiblity issue with n

const HeaderExplainContainer = styled.div`
    ${({ theme }) => theme.flex.flexOnly};
    //justify-content: space-between;
    position: relative;
    height: 219px;
    padding-left: 20px;
    padding-right: 20px;
    margin: 20px 20px 0 20px;
    border-radius: 10px;
    background: linear-gradient(180deg, #e9ebff -20.78%, #b1b7ed 80.37%);
`;

const Title = styled.h2`
    position: absolute;
    top: 35px;
    left: 25px;
    margin: 0;
    white-space: pre-line;
    z-index: 2;
    ${FontStyle(20, 28, '700', '#26294A', -1)};
`;

const ImageWrapper = styled.div`
    position: absolute;
    //min-width: 132px;
    //min-height: 153px;
    right: 23px;
    top: 18px;
    z-index: 1;
`;

export default QNAExplain;
